export interface ViewingTenant {
  tenantId: string;
  tenantName: string;
  /** Data URL or hosted image URL for this client's logo; empty if none set. */
  logoUrl: string;
}

const VIEWING_TENANT_KEY = "controlCenterViewingTenant";

export const getViewingTenant = (): ViewingTenant | null => {
  try {
    const raw = sessionStorage.getItem(VIEWING_TENANT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as ViewingTenant;
  } catch {
    return null;
  }
};

export const setViewingTenant = (tenant: ViewingTenant) => {
  sessionStorage.setItem(VIEWING_TENANT_KEY, JSON.stringify(tenant));
};

export const clearViewingTenant = () => {
  sessionStorage.removeItem(VIEWING_TENANT_KEY);
};
